import helper from '../helper';

export const addInlineMessages = () => {
  const woocommerceErrorsEl = document.querySelector('.woocommerce-error');

  if (woocommerceErrorsEl) {
    const woocommerceInlineErrorsEl =
      woocommerceErrorsEl.querySelectorAll('li[data-id]');

    const inlineErrorMessagesEl = document.querySelectorAll(
      '.c-form__group-message',
    );

    if (inlineErrorMessagesEl.length) {
      // eslint-disable-next-line no-unused-vars
      inlineErrorMessagesEl.forEach((s, index) => {
        // eslint-disable-next-line no-param-reassign
        s.style.display = 'none';
      });
    }

    if (woocommerceInlineErrorsEl.length) {
      // eslint-disable-next-line no-unused-vars
      woocommerceInlineErrorsEl.forEach((errorEl, index) => {
        const errorText = errorEl.innerText.trim();
        const targetFieldId = errorEl.dataset.id;

        if (errorText && targetFieldId) {
          const targetFieldEl =
            document.getElementById(targetFieldId).parentNode;
          const errorMessageField = targetFieldEl.querySelector(
            '.c-form__group-message',
          );

          if (targetFieldEl && errorMessageField) {
            targetFieldEl.classList.add('woocommerce-validated');
            targetFieldEl.classList.add('woocommerce-invalid');

            errorMessageField.innerText = errorText;
            // eslint-disable-next-line no-param-reassign
            errorEl.style.display = 'none';
          }
        }
      });

      let scrolled = false;
      // eslint-disable-next-line no-plusplus
      for (let i = 0, max = woocommerceInlineErrorsEl.length; i < max; i++) {
        woocommerceInlineErrorsEl[i].style.display = 'none';

        if (!scrolled) {
          helper.scrollToElement(woocommerceInlineErrorsEl[i]);
          scrolled = true;
        }
      }
    }
  }
};

jQuery(document.body).on('checkout_error', addInlineMessages);
